<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal scrollable size="lg" :visible="modal && modal.show" @hidden="onHidden" :content-in-form="false"
                   :title="$t('Activities')" :hide-footer="true" modal-class="mobile-full-screen">
      <div class="modal-height">
        <ActivityList :for="'condition_report'"
                      :actions="actions"
                      :value-visualizer="valueVisualizer"
                      :actions-to-hide-details-button="[]"
                      :has-search="false">
          <template v-slot:text="{activity}">
            {{ actions[activity.action] ? actions[activity.action].message : activity.action }}
          </template>
        </ActivityList>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import ArtisioModal from "@/core/components/artisio-modal/ArtisioModal";
  import {createNamespacedHelpers} from "vuex";
  import conditionReportsActivityHelper
    from "@/modules/condition-reports/ConditionReportActivityHelper";
  import ActivityList from "@/modules/activities/ActivityList";

  const {mapState, mapActions} = createNamespacedHelpers('activities');
  export default {
    name: "ConditionReportActivitiesModal",
    components: {ArtisioModal, ActivityList},
    data() {
      return {
        showDetailsModal: false,
        actions: conditionReportsActivityHelper.actions
      }
    },
    computed: {
      ...mapState({
        modal: state => state.tableData[state.tableSource],
      })
    },
    methods: {
      ...mapActions(['hideActivitiesModal']),
      valueVisualizer: conditionReportsActivityHelper.valueVisualizer,
      onHidden() {
        this.hideActivitiesModal();
      },
    },
  }
</script>

<style scoped>
  .modal-height {
    height: 60em
  }
</style>
